import { footerColumns } from "@/mocks/siteData";

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg text-background-50">
                包
              </span>
              <span className="font-heading text-xl tracking-wide text-background-50">包子漫画</span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-background-100/80">
              包子漫画的官方入口导航页，聚合 APP 下载、最新访问地址与在线看漫画功能。无论你习惯用网页还是客户端，都能从同一个入口出发，继续追更喜欢的作品。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {["iOS", "Android", "Windows", "macOS", "网页版"].map((p) => (
                <span
                  key={p}
                  className="rounded-full border border-background-100/20 px-3 py-1 text-xs text-background-100/85"
                >
                  {p}
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-base text-background-50">{col.title}</h3>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-100/80 transition-colors hover:text-secondary-300"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-100/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs leading-relaxed text-background-100/70">
            © 2026 包子漫画 · 官方入口导航页。页面内容与作品信息会随平台更新持续调整，请以实际展示为准。
          </p>
          <a
            href="#top"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-100/25 px-4 py-2 text-xs text-background-100/85 transition-colors hover:border-secondary-300 hover:text-secondary-300"
          >
            <i className="ri-arrow-up-line" aria-hidden="true" />
            回到顶部
          </a>
        </div>
      </div>
    </footer>
  );
}